import { FETCH_ALL_PURCHASES, FETCH_PAGINATE_PURCHASES, FETCH_CURRENT_PURCHASE, FETCH_PURCHASE_STATUSES } from './../../mutation-types';

export default {
  [FETCH_ALL_PURCHASES](state, purchases) {
    state.all = purchases;
  },

  [FETCH_PAGINATE_PURCHASES](state, { purchases, pagination }) {
    state.items = purchases;
    state.pagination = pagination;
  },

  [FETCH_PURCHASE_STATUSES](state, statuses) {
    state.statuses = statuses;
  },

  [FETCH_CURRENT_PURCHASE](state, purchase) {
    state.currentPurchase = purchase;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/purchase/mutations.js